<template>
    <div>
        <div class="w_1200 clearfix2 box_mh20">
            <div class="fl black6_text box_pt8 site_th">
                <span class="home_icon icon_public box_mr8"></span>
                <span class="text_m">当前位置：
                    <router-link tag="a" to="/">首页</router-link>
                    <span class="china">&gt;</span>
                    <span v-text="selectedJyzt"></span>
                </span>
            </div>
            <div class="fr" hidden>
                <Search/>
            </div>
        </div>
        <!--end一行-->

        <div class="clearfix2 box_mt20 w_1200">
            <div class="w_1200">
                <div class="clearfix2 gray_bj box_ph15 box_pw20">
                    <div class="fr black6_text box_pt8">共 <span v-text="pagination.total">0</span>条公告，每页显示<span v-text="params.rows"></span>条公告</div>

                    <div class="r_cell" v-if="selectedJyzt === '资料下载' || selectedJyzt === '其它公告'">
                        <select class="select_box box_ml10" v-model="params.qy" v-if="selectedJyzt === '其它公告'">
                            <option :value="null">选择区域</option>
                            <option v-for="(value,key,index) in qy" :key="index" :value="value" v-text="key"></option>
                        </select>
                        <input type="text" class="fill_text box_ml10" placeholder="请输入标题..." v-model="params.bt">
                        <input type="button" class="fill_btn box_ml10" value="搜索" @click="getAllData">
                    </div>

                    <div class="r_cell" v-else>
                        <input type="text" class="fill_text" placeholder="请输入宗地编号..." v-model="params.zybh">
                        <select class="select_box box_ml10" v-model="params.qy">
                            <option :value="null">选择区域</option>
                            <option v-for="(value,key,index) in qy" :key="index" :value="value" v-text="key"></option>
                        </select>
                        <input type="text" class="fill_text box_ml10" placeholder="请输入宗地名称..." v-model="params.xmmc">
                        <input type="button" class="fill_btn box_ml10" value="搜索" @click="getAllData">
                    </div>
                </div>
            </div>
            <!--end一行-->

            <table class="list_table blue_link box_c hover_table_bj box_mt20" v-if="selectedJyzt==='正在公告'">
                <thead>
                <tr class="black9_text">
                    <th width="20px;"></th>
                    <th width="60px;">所属区域</th>
                    <th width="80px;">交易类型</th>
                    <th width="150px;">宗地编号</th>
                    <th width="100px;">公告编号</th>
                    <th width="200px;">宗地名称</th>
                    <th width="80px;">公告发布时间</th>
                    <th width="80px;">公告结束时间</th>
                    <th width="30px;">操作</th>
                </tr>
                </thead>
                <tbody v-if="dataList !== undefined && dataList !== null && dataList.length>0">
                <tr v-for="(data,index) in dataList" :key="index">
                    <td><span class="num_box blue_bj" v-text="index+1">1</span></td>
                    <td v-text="data.qyText"></td>
                    <td v-text="data.jylxText"></td>
                    <td v-text="data.zybh"></td>
                    <td v-text="data.ggh"></td>
                    <td v-text="data.xmmc"></td>
                    <td v-text="data.ggfbsj"></td>
                    <td v-text="data.ggjssj"></td>
                    <td><a :href="detailUrl.zzgg(data.id)">查看</a></td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                    <td colspan="10" style="color: #999;display: none">暂无记录</td>
                </tr>
                </tbody>
            </table>

            <table class="list_table blue_link box_c hover_table_bj box_mt20" v-if="selectedJyzt==='竞价过程'">
                <thead>
                <tr class="black9_text">
                    <th width="20px;"></th>
                    <th width="60px;">所属区域</th>
                    <th width="80px;">交易类型</th>
                    <th width="150px;">宗地编号</th>
                    <th width="200px;">宗地名称</th>
                    <th width="80px;">挂牌竞价起始时间</th>
                    <th width="80px;">挂牌竞价截止时间</th>
                    <th width="80px;">竞买申请截止时间</th>
                    <th width="80px;">保证金到账截止时间</th>
                    <th width="80px;">交易状态</th>
                    <th width="30px;">操作</th>
                </tr>
                </thead>
                <tbody v-if="dataList !== undefined && dataList !== null && dataList.length>0">
                <tr v-for="(data,index) in dataList" :key="index">
                    <td><span class="num_box blue_bj" v-text="index+1">1</span></td>
                    <td v-text="data.qyText"></td>
                    <td v-text="data.jylxText"></td>
                    <td v-text="data.zybh"></td>
                    <td v-text="data.xmmc"></td>
                    <td v-text="data.gpqssj"></td>
                    <td v-text="data.gpjzsj"></td>
                    <td v-text="data.sgjzsj"></td>
                    <td v-text="data.bzjdzjzsj"></td>
                    <td v-text="data.jyztText"></td>
                    <td><a :href="detailUrl.zzgp(data.id)">查看</a></td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                    <td colspan="11" style="color: #999;display: none">暂无记录</td>
                </tr>
                </tbody>
            </table>

            <table class="list_table blue_link box_c hover_table_bj box_mt20" v-if="selectedJyzt==='竞价结果'">
                <thead>
                <tr class="black9_text">
                    <th width="20px;"></th>
                    <th width="60px;">所属区域</th>
                    <th width="80px;">交易类型</th>
                    <th width="150px;">宗地编号</th>
                    <th width="200px;">宗地名称</th>
                    <th width="80px;">起拍价</th>
                    <th width="80px;">成交价</th>
                    <th width="80px;">竞得人</th>
                    <th width="80px;">成交时间</th>
                    <th width="80px;">交易状态</th>
                    <th width="30px;">操作</th>
                </tr>
                </thead>
                <tbody v-if="dataList !== undefined && dataList !== null && dataList.length>0">
                <tr v-for="(data,index) in dataList" :key="index">
                    <td><span class="num_box blue_bj" v-text="index+1">1</span></td>
                    <td v-text="data.qyText"></td>
                    <td v-text="data.jylxText"></td>
                    <td v-text="data.zybh"></td>
                    <td v-text="data.xmmc"></td>
                    <td v-text="data.qsjwy + data.jgdwText"></td>
                    <td v-text="data.cjjwy ? data.cjjwy + data.jgdwText : '-'"></td>
                    <td v-text="data.jdr || '-'"></td>
                    <td v-text="data.cjsj || '-'"></td>
                    <td v-text="data.jyztText"></td>
                    <td><a :href="detailUrl.jjjg(data.id)">查看</a></td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                    <td colspan="11" style="color: #999;display: none">暂无记录</td>
                </tr>
                </tbody>
            </table>

            <table class="list_table blue_link box_c hover_table_bj box_mt20" v-if="selectedJyzt==='其它公告'">
                <thead>
                <tr class="black9_text">
                    <th width="20px;"></th>
                    <th width="60px;">所属区域</th>
                    <th width="150px;">宗地编号</th>
                    <th width="200px;">宗地名称</th>
                    <th width="200px;">公告标题</th>
                    <th width="80px;">发布时间</th>
                    <th width="80px;">公告类型</th>
                    <th width="30px;">操作</th>
                </tr>
                </thead>
                <tbody v-if="dataList !== undefined && dataList !== null && dataList.length>0">
                <tr v-for="(data,index) in dataList" :key="index">
                    <td><span class="num_box blue_bj" v-text="index+1">1</span></td>
                    <td v-text="data.fwjgjcText || '--'"></td>
                    <td v-text="data.xmbh"></td>
                    <td v-text="data.xmmc"></td>
                    <td v-text="data.bt || data.ggbt"></td>
                    <td v-text="data.fbsj"></td>
                    <td v-text="data.ggwzlxText"></td>
                    <td><a href="javascript:void(0);" @click="read(data.id)">查看</a></td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                    <td colspan="6" style="color: #999;display: none">暂无记录</td>
                </tr>
                </tbody>
            </table>

            <table class="list_table blue_link box_c hover_table_bj box_mt20" v-if="selectedJyzt==='资料下载'">
                <thead>
                <tr class="black9_text">
                    <th width="20px;"></th>
                    <th width="200px;">标题</th>
                    <th width="200px;">文件说明</th>
                    <th width="100px;">发布时间</th>
                    <th width="30px;">操作</th>
                </tr>
                </thead>
                <tbody v-if="dataList !== undefined && dataList !== null && dataList.length>0">
                <tr v-for="(data,index) in dataList" :key="data.id">
                    <td><span class="num_box blue_bj" v-text="index+1"></span></td>
                    <td v-text="data.bt"></td>
                    <td v-text="data.wjsm"></td>
                    <td v-text="data.fbsj"></td>
                    <td><a href="javascript:void(0);" @click="downloadFile($URL.FILE + data.extData.storedFilePath, data.wjsm)">下载</a></td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                    <td colspan="5" style="color: #999;display: none">暂无记录</td>
                </tr>
                </tbody>
            </table>

            <Pagination :pagination="pagination" :params="params" :start="start" :end="end" :maxEnd="maxEnd" @changeStartAndEnd="changeStartAndEnd"/>

        </div>
        <!--end一行-->
    </div>
</template>

<script>
    import {api} from "@/core/api"
    import {findKey, downloadFile} from '@/core/common'
    import axios from '@/core/http'
    import {detailUrl} from '@/core/getDetailUrl'
    import Ggzw from '@/components/Ggzw'
    import Search from "@/components/Search";
    import Pagination from "@/components/Pagination";

    export default {
        name: "List",
        components: {Pagination, Search},
        data() {
            return {
                detailUrl: detailUrl,
                qy: {},
                dataList: [],
                selectedJyzt: null,
                jyzt: {
                    "所有挂牌": "sygp",
                    "正在公告": "zzgg",
                    "竞价过程": "zzgp",
                    "结果公示": "jggs",
                    "更正公告": "gzgg",
                    "通知公告": "tzgg",
                    "资料下载": "zlxz",
                    "结果待公示": "zzzs",
                    "其它公告": "qtgg",
                    "竞价结果": "jjjg",
                },
                pagination: {
                    currentPage: 1,
                    rows: 10,
                    total: 0,
                    totalPage: 1
                },
                params: {
                    page: 1,
                    rows: 10,
                    zybh: null,
                    qy: null,
                    xmmc: null,
                    bt: null
                },
                start: 1,
                end: 1,
                maxEnd: 5,
            }
        },
        mounted() {
            let jyzt = window.location.pathname.split('/')[2];
            this.selectedJyzt = findKey(this.jyzt, jyzt);
            this.getQy();
            this.getAllData();
        },
        methods: {
            downloadFile,
            changeStartAndEnd(start, end) {
                this.start = start;
                this.end = end;
            },
            async getQy() {
                let res = await axios.get('/api/common/getQy');
                this.qy = res.data.data;
            },
            changeGglx(gglx) {
                this.selectedJyzt = gglx;
                this.params.qy = null;
                this.params.bt = null;
                this.getAllData()
            },
            getAllData() {
                this.params.page = 1;
                if (this.selectedJyzt === "所有挂牌") {
                    api.getSygpList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                    api.getSygpPagination(this.params).then(response => {
                        if (response.code === 200) {
                            this.pagination = response.data;
                            this.start = 1;
                            this.end = this.pagination.totalPage < this.maxEnd ? this.pagination.totalPage : this.maxEnd;
                        } else {
                            console.log(response.msg)
                        }
                    })
                } else if (this.selectedJyzt === "正在公告") {
                    api.getZzggList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                    api.getZzggPagination(this.params).then(response => {
                        if (response.code === 200) {
                            this.pagination = response.data;
                            this.start = 1;
                            this.end = this.pagination.totalPage < this.maxEnd ? this.pagination.totalPage : this.maxEnd;
                        } else {
                            console.log(response.msg)
                        }
                    })
                } else if (this.selectedJyzt === "竞价过程") {
                    api.getZzgpList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                    api.getZzgpPagination(this.params).then(response => {
                        if (response.code === 200) {
                            this.pagination = response.data;
                            this.start = 1;
                            this.end = this.pagination.totalPage < this.maxEnd ? this.pagination.totalPage : this.maxEnd;
                        } else {
                            console.log(response.msg)
                        }
                    })
                } else if (this.selectedJyzt === "资料下载") {
                    api.getZlxzList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                    api.getZlxzPagination(this.params).then(response => {
                        if (response.code === 200) {
                            this.pagination = response.data;
                            this.start = 1;
                            this.end = this.pagination.totalPage < this.maxEnd ? this.pagination.totalPage : this.maxEnd;
                        } else {
                            console.log(response.msg)
                        }
                    })
                } else if (this.selectedJyzt === "其它公告") {
                    api.getGtzyQtggList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                    api.getGtzyQtggPagination(this.params).then(response => {
                        if (response.code === 200) {
                            this.pagination = response.data;
                            this.start = 1;
                            this.end = this.pagination.totalPage < this.maxEnd ? this.pagination.totalPage : this.maxEnd;
                        } else {
                            console.log(response.msg)
                        }
                    })
                } else if (this.selectedJyzt === "竞价结果") {
                    api.getJjggList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                    api.getJjggPagination(this.params).then(response => {
                        if (response.code === 200) {
                            this.pagination = response.data;
                            this.start = 1;
                            this.end = this.pagination.totalPage < this.maxEnd ? this.pagination.totalPage : this.maxEnd;
                        } else {
                            console.log(response.msg)
                        }
                    })
                }
            },
            getDataByPage() {
                if (this.selectedJyzt === "所有挂牌") {
                    api.getSygpList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                } else if (this.selectedJyzt === "正在公告") {
                    api.getZzggList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                } else if (this.selectedJyzt === "竞价过程") {
                    api.getZzgpList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                } else if (this.selectedJyzt === "资料下载") {
                    api.getZlxzList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                } else if (this.selectedJyzt === "结果待公示") {
                    api.getZzzsList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                } else if (this.selectedJyzt === "其它公告") {
                    api.getGtzyQtggList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                } else if (this.selectedJyzt === "竞价结果") {
                    api.getJjggList(this.params).then(response => {
                        if (response.code === 200) {
                            this.dataList = response.data;
                        } else {
                            console.log(response.msg)
                        }
                    });
                }
            },
            read(id) {
                if (id === null) {
                    return;
                }
                let params = {};
                if (this.selectedJyzt === "通知公告") {
                    params = {category: "Tzgggl", id: id};
                } else if (this.selectedJyzt === "竞价结果") {
                    params = {category: "Ggwz", id: id};
                } else {
                    params = {category: "Ggwz", id: id};
                }

                api.getDetailById(params).then(response => {
                    let bt = response.data.ggbt || response.data.bt;
                    let content = response.data.ggzw || response.data.zw;

                    this.$layer.iframe({
                        content: {
                            content: Ggzw, //传递的组件对象
                            parent: this,//当前的vue对象
                            data: {
                                content: `<h2 style="font-weight: bold; margin: 20px auto; text-align: center;">${bt}</h2><div>${content}</div>`
                            }
                        },
                        area: ['1300px', '700px'],
                        title: response.data.ggwzlxText || '公告',
                        scrollbar: false
                    });
                });
            }
        },
        watch: {
            "params.page": {
                handler() {
                    this.getDataByPage()
                }
            },
            "$route": {
                handler() {
                    this.dataList = [];
                    let jyzt = window.location.pathname.split('/')[2];
                    this.selectedJyzt = findKey(this.jyzt, jyzt);
                    this.getAllData();
                }
            }
        }
    }
</script>
<style scoped>
    .d_tab_nav dd .tab_light {
        color: #35c2eb;
        border-bottom: 3px solid #35c2eb;
    }

    .d_tab_nav dd a::before {
        background-color: #35c2eb;
    }
</style>
